import React from 'react';
import styled, { css } from 'styled-components';

import Link from '@/components/Link';
import { colors } from '@/constants/theme';
import { HideScrollbar } from '@/components/styles';

import { StockTabsProps } from './types';

function StockTabs({ tabs, activeTab }: StockTabsProps) {
  return (
    <Component>
      {tabs.map(({ label, link }, index) => (
        <Tab key={index} to={link} isActive={activeTab === label}>
          {label}
        </Tab>
      ))}
    </Component>
  );
}

export default StockTabs;

const Component = styled.div`
  display: flex;
  overflow: auto;

  ${HideScrollbar}
`;

const Tab = styled(Link)<{ isActive: boolean }>`
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  padding: 15px 10px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid ${colors.main};
  white-space: nowrap;
  color: ${(props) => props.theme.black};

  &:not(:first-child) {
    margin-left: 10px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      pointer-events: none;
      background: ${colors.main};
      color: ${colors.white};
    `}
`;
